import React from 'react';

const UnderConstructionNotice = () => {
  return (
    <div className="bg-yellow-400 text-black p-4 text-center font-bold w-full">
      🚧 This website is currently under construction. Some features may be incomplete or unavailable. 🚧
    </div>
  );
};

export default UnderConstructionNotice;
